import { Ref } from 'vue'
import { SingleSelect } from '@/components/Fields/dataObjects/SingleSelect'
import { FreeText } from '@/components/Fields/dataObjects/FreeText'
import {
  CustomFieldDetailFragment,
  CustomFieldListFragment,
  CustomFieldSettings,
  CustomFieldType,
  CustomFieldValidationRules,
  TypeSupportingCustomFieldValues,
} from '@/gql/graphql'
import { CustomField } from '@/components/Fields/dataObjects/CustomField'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

export const CustomFieldTypeClasses = {
  [CustomFieldType.SingleSelect]: SingleSelect,
  [CustomFieldType.FreeText]: FreeText,
}

export const CustomFieldTypeGqlToInput = {
  [CustomFieldType.SingleSelect]: 'singleSelect',
  [CustomFieldType.FreeText]: 'freeText',
}

export function newInstanceOfCustomField(
  field:
    | (Pick<CustomFieldDetailFragment, 'appliesTo'> & Partial<CustomFieldDetailFragment>)
    | (Pick<CustomFieldListFragment, 'appliesTo'> & Partial<CustomFieldListFragment>),
  fieldType: CustomFieldType = CustomFieldType.FreeText,
): CustomField {
  return new CustomFieldTypeClasses[fieldType](field)
}

export function extractFieldsGqlVariables(field: Ref<CustomField>) {
  return {
    fieldType: field.value.fieldType,
    title: field.value.title!,
    slug: field.value.slug,
    visibility: field.value.visibility,
    approval: field.value.approval,
    apiOnly: field.value.apiOnly,
    description: field.value.description,
    settings: field.value.settings.toGraphQLInput(),
    options: field.value.optionsForGraphQL(),
  }
}

export function isCustomFieldRequired(customFieldSettings: CustomFieldSettings): boolean {
  return (
    customFieldSettings.validation.find(
      (rule: CustomFieldValidationRules) => rule === CustomFieldValidationRules.Required,
    ) !== undefined
  )
}

export function getCustomFieldCautionText(appliesTo: TypeSupportingCustomFieldValues): string {
  switch (appliesTo) {
    case TypeSupportingCustomFieldValues.Job:
      return $t('This field is already used by at least one job, edit with caution.')
    case TypeSupportingCustomFieldValues.TrustedContact:
      return $t('This field is already used by at least one trusted contact, edit with caution.')
    case TypeSupportingCustomFieldValues.Contract:
      return $t('This field is already used by at least one contract, edit with caution.')
    case TypeSupportingCustomFieldValues.PaymentRequest:
      return $t('This field is already used by at least one payment request, edit with caution.')
    default:
      return $t('This field is already in use. Edit with caution.')
  }
}

export function getAppliesToText(appliesTo: TypeSupportingCustomFieldValues): string {
  switch (appliesTo) {
    case TypeSupportingCustomFieldValues.Contract:
      return $t('Contract')
    case TypeSupportingCustomFieldValues.TrustedContact:
      return $t('Trusted Contact')
    case TypeSupportingCustomFieldValues.Job:
      return $t('Job')
    case TypeSupportingCustomFieldValues.PaymentRequest:
      return $t('Payment Request')
    default:
      return ''
  }
}
